import { render } from "./ComboForm.vue?vue&type=template&id=a87cfdba&scoped=true"
import script from "./ComboForm.vue?vue&type=script&lang=js"
export * from "./ComboForm.vue?vue&type=script&lang=js"

import "./ComboForm.vue?vue&type=style&index=0&id=a87cfdba&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a87cfdba"]])

export default __exports__